import { onBeforeUnmount, onMounted } from "vue";

export function useMediaPrintingEvents(
  beforePrint: (ev: Event) => any,
  afterPrint: (ev: Event) => any
) {
  onMounted(() => {
    window.addEventListener("beforeprint", beforePrint);
    window.addEventListener("afterprint", afterPrint);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("beforeprint", beforePrint);
    window.removeEventListener("afterprint", afterPrint);
  });
}
